module.exports = __webpack_public_path__ + "static/media/arrow_right_icon.3d3b1131.svg";